const es = {
  langName: 'Español',
  brand: {
    name: 'BULLISH',
    descriptor: 'TAX & ADVISORY',
    tagline: 'Estrategia detrás de cada decisión.',
    secondary: 'Diseñado en torno a su próximo paso.',
    legal: 'Bullish Accounting LLC',
  },
  nav: {
    whoWeServe: 'A quién ayudamos',
    expertise: 'Servicios',
    plans: 'Planes contables',
    allExpertise: 'Todos los servicios',
    howWeWork: 'Cómo trabajamos',
    about: 'Nosotros',
    insights: 'Insights',
    book: 'Solicitar una consulta estratégica',
    menu: 'Menú',
    close: 'Cerrar',
    language: 'Idioma',
    skip: 'Ir al contenido',
  },
  common: {
    learnMore: 'Conocer más',
    explore: 'Explorar',
    bookCta: 'Solicitar una consulta estratégica',
    exploreExpertise: 'Conozca nuestros servicios',
    relatedExpertise: 'Servicios relacionados',
    individualAnalysis:
      'Cada situación es distinta. Las consideraciones descritas aquí son de carácter general y cada caso requiere un análisis individual antes de emitir cualquier recomendación.',
    placeholder: 'Pendiente',
  },
  seo: {
    home: {
      title: 'Bullish Accounting | Asesoría Fiscal Estratégica',
      description:
        'Planificación fiscal estratégica, fiscalidad internacional y asesoramiento contable para empresarios e inversionistas en Estados Unidos.',
    },
    investors: {
      title: 'Inversionistas internacionales en EE. UU. | Bullish Accounting',
      description:
        'Orientación fiscal en EE. UU. para inversionistas extranjeros: estructuras de propiedad, bienes raíces, FIRPTA y declaraciones informativas.',
    },
    owners: {
      title: 'Asesoría fiscal para empresarios | Bullish Accounting',
      description: 'Planificación fiscal, cumplimiento complejo, contabilidad y asesoría continua para empresarios y empresas en crecimiento en EE. UU.',
    },
    expertise: {
      title: 'Nuestros servicios | Bullish Accounting',
      description:
        'Planificación fiscal estratégica, impuestos internacionales, bienes raíces en EE. UU., cumplimiento empresarial y contabilidad.',
    },
    strategic: {
      title: 'Planificación fiscal estratégica | Bullish Accounting',
      description: 'Planificación fiscal proactiva en EE. UU. para empresarios, inversionistas y situaciones empresariales complejas.',
    },
    international: {
      title: 'Impuestos internacionales | Bullish Accounting',
      description:
        'Entidades de propiedad extranjera, formularios 5471, 5472, 8865, 1040-NR y 1120-F, FIRPTA, créditos fiscales extranjeros y tratados.',
    },
    realestate: {
      title: 'Inversión y bienes raíces en EE. UU. | Bullish Accounting',
      description: 'Consideraciones fiscales para inversionistas extranjeros en bienes raíces en EE. UU.: alquileres, estructuras y transacciones.',
    },
    business: {
      title: 'Impuestos empresariales | Bullish Accounting',
      description: 'Preparación y cumplimiento fiscal para partnerships, corporaciones, S corporations y estructuras de propiedad complejas.',
    },
    accounting: {
      title: 'Contabilidad y asesoría continua | Bullish Accounting',
      description: 'Contabilidad, bookkeeping, reportes financieros y registros listos para impuestos, con asesoría continua y apoyo en nómina.',
    },
    howWeWork: {
      title: 'Cómo trabajamos | Bullish Accounting',
      description: 'Calificación inicial, consulta estratégica, propuesta personalizada y asesoría continua. Cada trabajo se cotiza de forma individual.',
    },
    about: {
      title: 'Sobre Bullish | Bullish Accounting',
      description: 'Una firma independiente de asesoría fiscal dirigida por sus fundadores, al servicio de empresarios e inversionistas internacionales.',
    },
    insights: {
      title: 'Análisis y recursos | Bullish Accounting',
      description: 'Perspectivas educativas sobre planificación fiscal en EE. UU. y cumplimiento transfronterizo. Próximamente.',
    },
    plans: {
      title: 'Planes contables y de asesoría | Bullish Accounting',
      description: 'Planes contables Basic, Basic Plus, Quarterly y Monthly, coordinados con sus declaraciones federales y estatales. Cotización individual.',
    },
    book: {
      title: 'Solicitar una consulta estratégica | Bullish Accounting',
      description: 'Cuéntenos su situación y solicite una consulta estratégica con los fundadores de Bullish. Revisamos cada solicitud de forma individual.',
    },
    review: {
      title: 'Comparta su experiencia | Bullish Accounting',
      description: 'Gracias por confiar en Bullish Accounting. Comparta su experiencia con nuestro equipo.',
    },
    privacy: { title: 'Política de privacidad | Bullish Accounting', description: 'Cómo Bullish Accounting LLC recopila, utiliza y protege la información enviada a través de bullishaccounting.com.' },
    terms: { title: 'Términos de uso | Bullish Accounting', description: 'Términos que rigen el uso de bullishaccounting.com, el sitio web de Bullish Accounting LLC.' },
    disclaimer: {
      title: 'Aviso profesional | Bullish Accounting',
      description: 'Aviso sobre servicios profesionales de Bullish Accounting LLC.',
    },
  },
  home: {
    hero: {
      overline: 'Impuestos en EE. UU. · Internacional · Asesoría',
      h1: 'Asesoría fiscal estratégica para empresarios e inversionistas internacionales.',
      text: 'Planificación fiscal en Estados Unidos, cumplimiento tributario internacional y asesoría contable, pensados para decisiones complejas, empresas en crecimiento y oportunidades transfronterizas.',
      values: [
        { t: 'Claridad', d: 'Una visión clara de su situación fiscal en EE. UU.' },
        { t: 'Confianza', d: 'Antes de decisiones financieras importantes' },
        { t: 'Decisiones informadas', d: 'Basadas en información financiera organizada' },
        { t: 'Acompañamiento', d: 'Con acceso directo a los fundadores' },
      ],
    },
    serve: {
      overline: 'A quién ayudamos',
      title: 'Dos tipos de clientes. Un mismo nivel de asesoría.',
      intro: 'Nuestro trabajo se centra en dos grupos cuyas decisiones fiscales suelen tener mayores consecuencias — y mayores oportunidades.',
    },
    expertise: {
      overline: 'Nuestros servicios',
      title: 'Asesoría organizada en torno a las decisiones que usted enfrenta.',
      intro: 'Cinco áreas de práctica, cada una con su propia profundidad. La contabilidad sigue siendo parte de lo que hacemos, al servicio de mejores decisiones fiscales y empresariales.',
    },
    why: {
      overline: 'Por qué Bullish',
      title: 'Una firma dirigida por sus fundadores, por convicción.',
      intro: 'Mantenemos una práctica deliberadamente enfocada para que cada relación con un cliente reciba atención directa y pensamiento estratégico.',
      items: [
        { title: 'Acceso directo a los fundadores', text: 'Usted trabaja directamente con las personas responsables de su caso, no con un equipo rotativo.' },
        { title: 'Relaciones de asesoría personalizadas', text: 'La asesoría se construye en torno a sus objetivos, su estructura y sus plazos.' },
        { title: 'Experiencia en EE. UU. e internacional', text: 'Atendemos asuntos locales y las preguntas transfronterizas que surgen cuando personas, capital y entidades están en más de un país.' },
        { title: 'Estrategia más allá de la declaración anual', text: 'La declaración es el resultado. El valor está en la planificación y en las decisiones que se toman durante el año.' },
        { title: 'Visión fiscal y contable integrada', text: 'Analizamos su contabilidad y su posición fiscal en conjunto, para que una respalde a la otra.' },
        { title: 'Español e inglés', text: 'Comunicación clara en el idioma con el que usted se sienta más cómodo.' },
      ],
    },
    process: {
      overline: 'Cómo trabajamos',
      title: 'Un camino claro desde la primera conversación hasta el acompañamiento continuo.',
      cta: 'Ver modalidades de contratación',
    },
    leadership: {
      overline: 'Liderazgo',
      title: 'Conozca a los fundadores.',
      cta: 'Sobre Bullish',
    },
    final: {
      title: '¿Tiene por delante una decisión importante?',
      text: 'Comience con una consulta estratégica. Revisaremos su situación, identificaremos las preguntas clave y le explicaremos cómo podemos ayudarle.',
      secondary: 'Cómo trabajamos',
    },
  },
  process: [
    { title: 'Calificación inicial', text: 'Usted comparte una breve descripción de su situación. Confirmamos si encaja con nuestra práctica antes de coordinar cualquier reunión.' },
    { title: 'Consulta estratégica', text: 'Una sesión enfocada con un fundador para entender sus objetivos, su estructura y las preguntas más relevantes.' },
    { title: 'Evaluación de la situación y necesidades', text: 'Analizamos la información conversada e identificamos obligaciones, riesgos y oportunidades de planificación.' },
    { title: 'Propuesta de trabajo personalizada', text: 'Recibe una propuesta escrita con alcance, entregables, plazos y honorarios adaptados a su caso.' },
    { title: 'Implementación y acompañamiento', text: 'Cuando corresponde, ejecutamos el trabajo y seguimos disponibles a medida que su situación evoluciona.' },
  ],
  audiences: {
    investors: {
      name: 'Inversionistas internacionales y bienes raíces en EE. UU.',
      short:
        'Inversionistas extranjeros — especialmente con vínculos en Latinoamérica — que necesitan orientación sobre impuestos en EE. UU., estructuras de propiedad, inversiones inmobiliarias y cumplimiento fiscal internacional.',
      overline: 'A quién servimos',
      h1: 'Orientación fiscal para inversionistas internacionales en Estados Unidos.',
      intro:
        'Invertir en Estados Unidos desde el exterior plantea preguntas que un inversionista local rara vez enfrenta: cómo mantener la inversión, qué se debe declarar, cómo se gravan los ingresos y las ventas, y cómo interactúan las normas de EE. UU. con las de su país. Le ayudamos a entender esas preguntas antes de tomar decisiones — y a cumplir después.',
      challengesTitle: 'Preguntas en las que solemos ayudar',
      challenges: [
        '¿Cómo conviene mantener una propiedad o participación en EE. UU.: a título personal, mediante una entidad estadounidense u otra estructura?',
        '¿Qué obligaciones de declaración e información aplican a un propietario extranjero?',
        '¿Cómo tributan los ingresos por alquiler y qué deducciones pueden estar disponibles?',
        '¿Qué ocurre fiscalmente al vender una propiedad en EE. UU., incluida la retención FIRPTA?',
        '¿Cómo pueden influir un tratado tributario o los créditos fiscales extranjeros en el resultado?',
        '¿Cómo coordinar la estructuración legal y la planificación patrimonial con abogados calificados?',
      ],
      approachTitle: 'Cómo trabajamos con inversionistas internacionales',
      approach: [
        'Comunicación en español e inglés, con explicaciones adaptadas a quienes se inician en el sistema estadounidense.',
        'Análisis de las implicaciones fiscales de su estructura antes de invertir, cuando es posible.',
        'Coordinación con sus abogados y asesores en Estados Unidos y en el exterior.',
        'Cumplimiento continuo para atender cada año las obligaciones de declaración.',
      ],
      services: ['international', 'realestate', 'strategic'],
    },
    owners: {
      name: 'Dueños de negocios y empresas en crecimiento',
      short:
        'Empresarios y empresas en crecimiento que necesitan planificación fiscal, cumplimiento complejo, contabilidad y asesoría continua a medida que sus operaciones se vuelven más sofisticadas.',
      overline: 'A quién servimos',
      h1: 'Estrategia fiscal y asesoría para empresarios y empresas en crecimiento.',
      intro:
        'Cuando una empresa crece, también crece el costo de las decisiones fiscales reactivas. La elección de entidad, la compensación de los socios, los acuerdos entre varios dueños, la expansión y los reportes se benefician de un enfoque planificado. Trabajamos con empresarios que buscan un aliado fiscal y contable que piense con anticipación.',
      challengesTitle: 'Dónde solemos aportar valor',
      challenges: [
        'Planificar el impacto fiscal de las decisiones importantes antes de tomarlas.',
        'Revisar si la entidad y la estructura de propiedad actuales siguen siendo adecuadas.',
        'Gestionar el cumplimiento de partnerships, corporaciones y S corporations.',
        'Mantener una contabilidad precisa, oportuna y lista para los impuestos.',
        'Coordinar obligaciones de nómina e impuestos sobre ventas, cuando aplique.',
        'Atender cuestiones transfronterizas cuando socios, clientes u operaciones están fuera de EE. UU.',
      ],
      approachTitle: 'Cómo trabajamos con empresarios',
      approach: [
        'Acceso directo a un fundador que conoce tanto su posición fiscal como su contabilidad.',
        'Conversaciones de planificación durante todo el año, no solo en temporada de impuestos.',
        'Propuestas claras con alcance y honorarios definidos.',
        'Apoyo contable dimensionado según lo que su empresa realmente necesita.',
      ],
      services: ['strategic', 'business', 'accounting'],
    },
  },
  expertisePage: {
    overline: 'Nuestros servicios',
    h1: 'Profundidad donde más importa.',
    intro:
      'Nuestra práctica se organiza en cinco áreas. La planificación fiscal estratégica y el trabajo internacional encabezan nuestra práctica; la contabilidad y el cumplimiento respaldan las decisiones que hay detrás.',
  },
  serviceLabels: {
    scope: 'Qué puede incluir',
    whoFor: 'Para quién es',
    forms: 'Formularios y regímenes frecuentes',
    cta: 'Converse con nosotros sobre su situación',
    ctaText: 'Todo trabajo comienza por entender sus circunstancias. Solicite una consulta estratégica para empezar.',
  },
  services: {
    strategic: {
      name: 'Planificación fiscal estratégica',
      short: 'Planificación fiscal para empresarios, inversionistas y situaciones empresariales complejas en EE. UU.',
      h1: 'Planificación fiscal estratégica para decisiones de peso.',
      intro:
        'Los buenos resultados fiscales rara vez se logran en temporada de declaraciones. Surgen de entender las implicaciones de una decisión antes de tomarla — y de revisarlas cuando cambian las circunstancias.',
      scope: [
        'Planificación fiscal durante todo el año para empresarios e inversionistas',
        'Análisis del impacto fiscal de transacciones y decisiones relevantes',
        'Revisión de la elección de entidad y de la estructura de propiedad',
        'Consideraciones sobre compensación y distribuciones a los socios',
        'Planificación de impuestos estimados y de flujo de caja',
        'Planificación plurianual a medida que evoluciona la empresa o el portafolio',
      ],
      whoFor: [
        'Empresarios con operaciones en crecimiento o en transformación',
        'Inversionistas con múltiples fuentes de ingreso o entidades',
        'Clientes ante una venta, adquisición, expansión o reestructuración',
      ],
    },
    international: {
      name: 'Impuestos internacionales y transfronterizos',
      short: 'Entidades estadounidenses de propiedad extranjera, declaraciones informativas internacionales, FIRPTA y tratados.',
      h1: 'Cumplimiento fiscal internacional y transfronterizo.',
      intro:
        'Cuando personas, entidades o ingresos cruzan fronteras, las obligaciones fiscales en EE. UU. se multiplican — y muchas son declaraciones informativas con sanciones importantes por incumplimiento. Ayudamos a nuestros clientes a entender qué normas aplican y a cumplirlas de forma consistente.',
      scope: [
        'Cumplimiento fiscal de entidades estadounidenses de propiedad extranjera',
        'Declaraciones informativas internacionales',
        'Declaraciones de personas no residentes y de corporaciones extranjeras',
        'Consideraciones sobre créditos fiscales extranjeros',
        'Propiedad y transacciones transfronterizas',
        'Cumplimiento FIRPTA en la disposición de bienes inmuebles en EE. UU.',
        'Revisión de las consideraciones de tratados tributarios aplicables',
      ],
      forms: ['Form 5471', 'Form 5472', 'Form 8865', 'Form 1040-NR', 'Form 1120-F', 'FIRPTA'],
      whoFor: [
        'Personas y empresas extranjeras con entidades o propiedades en EE. UU.',
        'Personas estadounidenses con participaciones en corporaciones o sociedades extranjeras',
        'Empresas con socios, operaciones o transacciones transfronterizas',
      ],
    },
    realestate: {
      name: 'Inversión y bienes raíces en EE. UU.',
      short: 'Consideraciones fiscales para inversionistas extranjeros, propiedades en alquiler, estructuras de propiedad y transacciones inmobiliarias.',
      h1: 'Impuestos sobre inversiones y bienes raíces en EE. UU.',
      intro:
        'Los bienes raíces suelen ser la primera inversión en EE. UU. de un cliente internacional. La forma de adquirir, mantener, alquilar y finalmente vender una propiedad tiene consecuencias fiscales en cada etapa. Ayudamos a los inversionistas a entenderlas y a cumplir durante toda la vida de la inversión.',
      scope: [
        'Consideraciones fiscales antes de adquirir bienes raíces en EE. UU.',
        'Análisis de estructuras de propiedad desde la perspectiva fiscal',
        'Declaración fiscal de propiedades en alquiler',
        'Implicaciones fiscales de ventas y otras transacciones inmobiliarias',
        'Consideraciones FIRPTA para vendedores extranjeros',
        'Coordinación de la estructuración legal y la planificación patrimonial con abogados calificados, cuando corresponda',
      ],
      whoFor: [
        'Inversionistas extranjeros que compran o mantienen propiedades en EE. UU.',
        'Propietarios de inmuebles en alquiler en Estados Unidos',
        'Inversionistas que planean vender, permutar o reestructurar sus inmuebles',
      ],
    },
    business: {
      name: 'Impuestos empresariales y cumplimiento complejo',
      short: 'Preparación y cumplimiento fiscal para partnerships, corporaciones, S corporations y estructuras de propiedad complejas.',
      h1: 'Impuestos empresariales y cumplimiento complejo.',
      intro:
        'El cumplimiento de empresas con varios socios, entidades o jurisdicciones exige más que completar formularios: requiere entender cómo encajan las piezas. Preparamos y coordinamos las declaraciones empresariales con esa visión completa.',
      scope: [
        'Preparación de declaraciones empresariales federales y estatales',
        'Declaraciones de partnerships e información para los socios',
        'Cumplimiento de C corporations y S corporations',
        'Estructuras con múltiples entidades y propiedad compleja',
        'Coordinación entre la contabilidad y las declaraciones fiscales',
        'Respuesta a notificaciones fiscales de rutina relacionadas con nuestros trabajos',
      ],
      whoFor: [
        'Partnerships y LLC con varios miembros',
        'Corporaciones y S corporations',
        'Grupos con varias entidades relacionadas o socios extranjeros',
      ],
    },
    accounting: {
      name: 'Contabilidad y asesoría continua',
      short: 'Contabilidad, bookkeeping, reportes financieros y registros listos para impuestos, con asesoría continua.',
      h1: 'Contabilidad al servicio de mejores decisiones.',
      intro:
        'Unos números confiables son la base de una buena planificación fiscal. Nuestros servicios contables mantienen sus registros precisos y listos para los impuestos, y le brindan los reportes financieros que necesita para dirigir su empresa con confianza.',
      scope: [
        'Contabilidad y bookkeeping',
        'Reportes financieros',
        'Registros financieros listos para impuestos',
        'Asesoría contable continua',
        'Apoyo en nómina e impuestos sobre ventas, cuando aplique',
      ],
      whoFor: [
        'Empresas que quieren alinear su contabilidad con su estrategia fiscal',
        'Empresarios que necesitan información financiera oportuna y consistente',
        'Clientes de nuestra práctica fiscal que prefieren un enfoque integrado',
      ],
    },
  },
  howWeWork: {
    overline: 'Cómo trabajamos',
    h1: 'Trabajos claros, diseñados en torno a su situación.',
    intro:
      'No ofrecemos paquetes iguales para todos. Cada relación comienza por entender sus circunstancias y cada propuesta se adapta al alcance y la complejidad del trabajo.',
    processTitle: 'Nuestro proceso',
    modelsTitle: 'Modalidades de contratación',
    models: [
      {
        name: 'Consulta estratégica',
        priceNote: 'Se coordina tras revisar su solicitud',
        text: 'Una sesión enfocada con un fundador para revisar su situación, identificar las preguntas clave y plantear los posibles próximos pasos.',
        badge: 'Punto de partida',
      },
      {
        name: 'Asesoría fiscal por proyecto',
        priceNote: 'Cotización según alcance y complejidad',
        text: 'Proyectos definidos, como el análisis de una transacción, la revisión de una estructura o un asunto de cumplimiento específico.',
      },
      {
        name: 'Asesoría estratégica continua',
        priceNote: 'Relación recurrente, cotizada de forma individual',
        text: 'Acceso durante todo el año a asesoría fiscal estratégica a medida que evolucionan su empresa o sus inversiones.',
      },
      {
        name: 'Cumplimiento fiscal y contabilidad',
        priceNote: 'Cotización según tipo de entidad, obligaciones, complejidad y frecuencia',
        text: 'Preparación de declaraciones e informes, y servicios contables dimensionados según sus necesidades.',
      },
    ],
    note: 'Cada trabajo se evalúa de forma individual y se cotiza según su alcance y complejidad. Las condiciones se confirman por escrito antes de iniciar cualquier trabajo.',
  },
  plansPage: {
    overline: 'Planes contables y de asesoría',
    h1: 'Apoyo contable al ritmo de su empresa.',
    intro: 'Cuatro planes, desde el cumplimiento anual hasta la contabilidad mensual. Cada plan coordina su contabilidad con sus declaraciones federales y estatales, y complementa nuestra asesoría fiscal estratégica e internacional.',
    labels: { idealFor: 'Ideal para', bookkeeping: 'Contabilidad', tax: 'Cumplimiento fiscal y coordinación', meetings: 'Reuniones y comunicación', frequency: 'Frecuencia' },
    frequency: { basic: 'Anual', 'basic-plus': 'Anual', quarterly: 'Trimestral', monthly: 'Mensual' },
    diff: {
      basic: 'Bajo volumen de transacciones · una cuenta bancaria',
      'basic-plus': 'Mayor volumen de transacciones · varias cuentas bancarias',
      quarterly: 'Revisiones trimestrales · orientación sobre impuestos estimados · reunión trimestral',
      monthly: 'Reportes mensuales · reuniones trimestrales · comunicación continua por email',
    },
    cta: 'Solicitar una propuesta personalizada',
    view: 'Ver detalles del plan',
    close: 'Cerrar detalles',
    summaryTitle: 'Cómo elegir el ritmo adecuado',
    summary: [
      { t: 'Anual — Basic y Basic Plus', d: 'Contabilidad de cierre de año y cumplimiento fiscal para empresas que no necesitan contabilidad mensual. Basic se adapta a un bajo volumen de transacciones y una cuenta bancaria; Basic Plus atiende mayor volumen y varias cuentas.' },
      { t: 'Trimestral', d: 'Contabilidad y revisiones financieras trimestrales, estados financieros trimestrales, orientación sobre impuestos estimados cuando aplique y una reunión de revisión trimestral.' },
      { t: 'Mensual', d: 'Contabilidad y reportes mensuales para una supervisión continua, con una reunión de revisión cada trimestre y comunicación continua por email.' },
    ],
    note: 'Cada trabajo se evalúa de forma individual y se cotiza según el volumen de transacciones, las cuentas y las necesidades. Las condiciones se confirman por escrito antes de iniciar cualquier trabajo.',
    teaser: { overline: 'Planes contables', title: 'Contabilidad confiable, a la medida de su empresa.', text: 'Basic, Basic Plus, Quarterly y Monthly — desde el cumplimiento anual hasta la contabilidad mensual, coordinados con sus declaraciones.', cta: 'Comparar planes contables' },
  },
  about: {
    overline: 'Sobre Bullish',
    h1: 'Una firma independiente de asesoría fiscal, dirigida por sus fundadores.',
    paragraphs: [
      'Bullish nació para ofrecer a empresarios e inversionistas internacionales algo que suele ser difícil de encontrar: atención directa y estratégica a sus asuntos fiscales en Estados Unidos, en español y en inglés.',
      'Mantenemos una práctica enfocada. Eso permite que los fundadores participen directamente en cada relación y piensen más allá de la declaración anual: en la estructura, los tiempos y las decisiones por venir.',
      'BULLISH Tax & Advisory es la marca bajo la cual Bullish Accounting LLC presta sus servicios.',
    ],
    principlesTitle: 'Lo que guía nuestro trabajo',
    principles: [
      { title: 'Primero la estrategia', text: 'Partimos de sus objetivos y trabajamos hacia la estructura y el cumplimiento adecuados.' },
      { title: 'Franqueza', text: 'Le decimos lo que vemos, incluso cuando un tema excede nuestro alcance y se necesita otro profesional.' },
      { title: 'Continuidad', text: 'Las relaciones de largo plazo nos permiten entender su situación en profundidad.' },
    ],
    leadershipTitle: 'Liderazgo',
    independence:
      'Bullish Accounting LLC es una firma independiente. No es una firma de CPA y no presta servicios de auditoría, atestiguamiento ni otros que requieran licencia de CPA.',
  },
  founders: [
    {
      name: 'Leonardo Rifa',
      role: 'Cofundador',
      initials: 'LR',
      credential: 'Título universitario en Economía',
      bio: 'Leonardo es cofundador de Bullish y profesional en impuestos y contabilidad. Tiene un título universitario en Economía y trabaja directamente con los clientes de la firma.',
      email: 'lrifa@bullishaccounting.com',
    },
    {
      name: 'Daniel Lariot',
      role: 'Cofundador',
      initials: 'DL',
      credential: 'Título universitario en Contabilidad y Finanzas',
      bio: 'Daniel es cofundador de Bullish. Tiene un título universitario en Contabilidad y Finanzas y trabaja directamente con los clientes de la firma.',
      email: 'dlariot@bullishaccounting.com',
    },
  ],
  insights: {
    overline: 'Insights',
    h1: 'Análisis y recursos educativos.',
    intro: 'Perspectivas prácticas sobre planificación fiscal en EE. UU. y cumplimiento transfronterizo. Nuestros primeros artículos están en preparación.',
    topicsTitle: 'Próximos temas',
    topics: [
      'Planificación fiscal en EE. UU. para empresarios',
      'Fundamentos fiscales en EE. UU. para inversionistas internacionales',
      'FIRPTA: lo que deben saber los vendedores extranjeros de inmuebles en EE. UU.',
      'LLC de propiedad extranjera y el formulario 5472',
      'Cumplimiento transfronterizo y declaraciones informativas',
    ],
    empty: 'Aún no se han publicado artículos.',
  },
  book: {
    overline: 'Solicitar una consulta estratégica',
    h1: 'Cuéntenos su situación.',
    intro:
      'Comparta algunos datos y revisaremos su solicitud. Si encaja con nuestra práctica, le contactaremos para coordinar una consulta estratégica y explicarle cómo podemos trabajar juntos.',
    steps: ['Envíe su solicitud', 'La revisamos de forma individual', 'Le contactamos con los próximos pasos'],
    notConfirmed: 'El envío de este formulario no confirma una cita ni crea una relación de asesoría.',
    notice:
      'Por favor no incluya números de Seguro Social, números de identificación fiscal, datos bancarios, declaraciones de impuestos ni otros documentos en este formulario. Si iniciamos un trabajo, le indicaremos un medio seguro para compartir documentos.',
    form: {
      name: 'Nombre completo',
      email: 'Email',
      phone: 'Teléfono (opcional)',
      category: '¿Cuál le describe mejor?',
      country: 'País de residencia',
      service: 'Servicio principal que necesita',
      language: 'Idioma preferido',
      message: 'Describa brevemente su situación',
      messagePlaceholder: '¿Qué decisión o pregunta tiene por delante? Evite incluir datos personales o financieros sensibles.',
      select: 'Seleccione…',
      submit: 'Solicitar una consulta estratégica',
      planPrefix: 'Me interesa una propuesta personalizada para el plan contable:',
      sending: 'Enviando…',
      success: 'Gracias. Hemos recibido su solicitud. Esto no es una confirmación de cita: la revisaremos y le contactaremos con los próximos pasos.',
      consent: 'Acepto que Bullish Accounting LLC utilice la información de este formulario para revisar y responder a mi solicitud, según se describe en la',
      consentLink: 'Política de privacidad',
      required: 'Por favor complete este campo.',
      invalidEmail: 'Por favor ingrese un email válido.',
      consentRequired: 'Por favor acepte los términos de privacidad para enviar su solicitud.',
      error: 'Hubo un problema al enviar su solicitud. Por favor intente de nuevo.',
      rateLimited: 'Ha enviado varias solicitudes recientemente. Por favor intente más tarde.',
    },
    categories: [
      { value: 'international_investor', label: 'Inversionista internacional / bienes raíces en EE. UU.' },
      { value: 'business_owner', label: 'Dueño de negocio / empresa en crecimiento' },
      { value: 'other', label: 'Otro' },
    ],
    serviceOther: { value: 'not_sure', label: 'Aún no lo sé' },
    languages: [
      { value: 'es', label: 'Español' },
      { value: 'en', label: 'English' },
    ],
    contactTitle: 'Contacto directo',
    qrTitle: 'Guarde nuestro contacto',
    qrText: 'Escanee para agregar Bullish a los contactos de su teléfono.',
  },
  testimonials: {
    overline: 'Testimonios de clientes',
    title: 'Lo que dicen nuestros clientes',
    count: (n) => (n === 1 ? '1 cliente ha compartido su experiencia' : `${n} clientes han compartido su experiencia`),
    swipe: 'Deslice para ver más',
    formTitle: 'Comparta su experiencia',
    formText: 'Los comentarios serán revisados antes de ser publicados.',
    name: 'Nombre',
    email: 'Email',
    comment: 'Su comentario',
    commentPlaceholder: 'Comparta su experiencia con Bullish…',
    rating: 'Calificación',
    submit: 'Enviar comentario',
    sending: 'Enviando…',
    success: '¡Gracias por su comentario! Será revisado antes de ser publicado.',
    error: 'Hubo un problema al enviar su comentario. Por favor intente de nuevo.',
    emptyTitle: 'La perspectiva de nuestros clientes',
    empty: 'Construimos relaciones de largo plazo, un trabajo a la vez. Las opiniones de nuestros clientes se compartirán aquí a medida que se publiquen.',
    emptyCta: '¿Ha trabajado con nosotros? Valoramos mucho su opinión.',
    required: 'Por favor complete este campo.',
    invalidEmail: 'Por favor ingrese un email válido.',
  },
  review: {
    overline: 'Reseñas de clientes',
    h1: 'Gracias por confiar en Bullish.',
    intro: 'Su opinión nos ayuda a servir mejor a cada cliente. Comparta unas palabras sobre su experiencia con nuestro equipo — los fundadores leen cada reseña.',
    privacy: 'Las reseñas se publican solo después de ser aprobadas por nuestro equipo. Si se publica, se muestran su nombre, calificación y comentario; su email nunca se publica. Consulte nuestra',
    googleTitle: '¿Prefiere dejarnos una reseña en Google?',
    googleText: 'También puede compartir una reseña pública en nuestro Perfil de Empresa de Google.',
    googleCta: 'Dejar una reseña en Google',
  },
  whatsapp: {
    label: (name) => `Escribir a ${name} por WhatsApp`,
    message: 'Hola, visité la página de Bullish Accounting y me gustaría recibir información sobre sus servicios de asesoría fiscal.',
  },
  footer: {
    expertise: 'Servicios',
    firm: 'Firma',
    legal: 'Legal',
    follow: 'Síganos',
    rights: 'Todos los derechos reservados.',
    review: 'Dejar una reseña',
    disclaimer:
      'Bullish Accounting LLC no es una firma de CPA y no presta servicios de auditoría ni atestiguamiento. La información de este sitio es de carácter general y no constituye asesoría fiscal, legal ni financiera. No existe relación de asesoría hasta la firma de un acuerdo de servicios.',
  },
  legal: {
    privacy: {
      h1: 'Política de privacidad',
      sections: [
        { h: 'Responsable', p: 'Este sitio, bullishaccounting.com, es operado por Bullish Accounting LLC, que presta sus servicios bajo la marca BULLISH Tax & Advisory. Bullish Accounting LLC es responsable de la información personal recopilada a través de este sitio. Las consultas sobre esta política pueden enviarse a lrifa@bullishaccounting.com.' },
        {
          h: 'Información que usted proporciona',
          p: [
            'Formulario de consulta y contacto: su nombre, email, teléfono opcional, categoría de cliente, país de residencia, servicio de interés, idioma preferido y su mensaje. Cuando solicita una propuesta para uno de nuestros Planes contables, el nombre del plan seleccionado se añade a su mensaje.',
            'Formulario de testimonios: su nombre, email, calificación y comentario.',
            'Este sitio no solicita números de Seguro Social, números de identificación fiscal, datos bancarios ni documentos tributarios. Por favor no los incluya en su mensaje.',
          ],
        },
        { h: 'Registro del consentimiento de privacidad', p: 'Antes de enviar una solicitud de consulta, usted debe confirmar que acepta el uso de su información según se describe en esta política. Guardamos un registro de esa confirmación junto con su solicitud y la fecha y hora en que fue recibida.' },
        {
          h: 'Información técnica y de seguridad',
          p: [
            'Para proteger el sitio contra spam y abusos, nuestro servidor utiliza su dirección IP para limitar envíos repetidos de formularios e intentos repetidos de inicio de sesión o de restablecimiento de contraseña. Estos registros temporales de seguridad se eliminan automáticamente, por lo general en el plazo de una hora. Los formularios también contienen un campo oculto que sirve para detectar spam automatizado.',
            'Los intentos de inicio de sesión en el área de administración, que solo utilizan miembros autorizados de nuestro equipo, se registran durante un tiempo limitado para evitar accesos no autorizados.',
            'Como en la mayoría de los sitios web, nuestra infraestructura de alojamiento puede procesar información técnica estándar, como su dirección IP y datos de su navegador, para entregar las páginas y mantener la seguridad del servicio.',
          ],
        },
        { h: 'Uso de la información', p: 'Usamos la información que usted proporciona para responder a su solicitud, evaluar si podemos ayudarle y de qué manera, preparar una propuesta cuando la solicita y comunicarnos con usted sobre un posible trabajo. Usamos los testimonios recibidos para revisarlos y, si se aprueban, publicarlos. Usamos la información técnica solo para operar y proteger el sitio.' },
        { h: 'Testimonios', p: 'Los testimonios enviados a través del sitio se guardan como pendientes y nuestro equipo los revisa antes de publicar nada. Si un testimonio se aprueba, su nombre, calificación y comentario se muestran en el sitio; su email nunca se publica. Los testimonios que no se aprueban se eliminan.' },
        {
          h: 'Proveedores de servicios',
          p: [
            'Utilizamos un proveedor de alojamiento e infraestructura en la nube en el que funcionan el sitio y su base de datos, y un proveedor de envío de emails que envía notificaciones a nuestro equipo. Cuando usted envía un formulario, los datos que proporciona se envían por email a nuestra cuenta de correo empresarial para que podamos responderle. Estos proveedores procesan la información en nuestro nombre para prestar sus servicios.',
            'No hemos instalado en este sitio herramientas de analítica, publicidad ni seguimiento de marketing de terceros, y sus tipografías e imágenes se sirven desde nuestro propio sitio y no desde servicios externos. Si sigue nuestro enlace a Instagram, usted sale de este sitio y se aplica la política de privacidad de Instagram.',
          ],
        },
        {
          h: 'Cookies y tecnologías similares',
          p: [
            'El código propio del sitio no utiliza cookies ni almacenamiento del navegador con fines de analítica, publicidad o seguimiento. Solo crea una cookie: una cookie de seguridad estrictamente necesaria que se genera cuando un administrador autorizado inicia sesión en el área de administración. Los visitantes que no inician sesión no la reciben.',
            'Nuestros proveedores de alojamiento y de red pueden crear sus propias cookies técnicas al entregar las páginas, por ejemplo para gestionar las conexiones y proteger el sitio contra tráfico automatizado. No utilizamos estas cookies con fines de publicidad ni de marketing.',
          ],
        },
        { h: 'Conservación y eliminación', p: 'No hemos establecido un plazo fijo de conservación. Las solicitudes de consulta y los testimonios aprobados permanecen en nuestros registros hasta que se eliminan, y las copias de las notificaciones de formularios permanecen en nuestra cuenta de correo empresarial hasta que se eliminan. Los testimonios no aprobados se eliminan y los registros temporales de seguridad se eliminan automáticamente. Usted puede pedirnos en cualquier momento que eliminemos su información, como se indica más abajo.' },
        { h: 'Seguridad', p: 'Aplicamos medidas razonables para proteger la información, incluidas conexiones cifradas, acceso administrativo protegido con contraseña y limitado a miembros autorizados de nuestro equipo, y protecciones contra spam e intentos repetidos de inicio de sesión. Ningún sitio web ni método de transmisión por internet es completamente seguro, y no podemos garantizar una seguridad absoluta.' },
        { h: 'Sus solicitudes', p: 'Puede solicitar acceder, corregir o eliminar la información personal que envió a través de este sitio escribiendo a lrifa@bullishaccounting.com. Es posible que necesitemos confirmar su identidad antes de atender una solicitud.' },
        { h: 'Actualizaciones', p: 'Podemos actualizar esta política. La versión vigente siempre estará publicada en esta página.' },
      ],
    },
    terms: {
      h1: 'Términos de uso',
      sections: [
        { h: 'Uso de este sitio', p: 'Este sitio es proporcionado por Bullish Accounting LLC, que opera bajo la marca BULLISH Tax & Advisory, con fines de información general sobre la firma y sus servicios. Al utilizar el sitio, usted acepta estos términos. Si no los acepta, por favor no utilice el sitio.' },
        { h: 'No constituye asesoría individualizada', p: 'El contenido de este sitio es general y educativo. No constituye asesoría fiscal, legal, contable ni financiera individualizada y no debe utilizarse sin que un profesional calificado revise los hechos y circunstancias específicos de su caso.' },
        { h: 'No existe relación de cliente', p: 'Enviar una solicitud de consulta o un testimonio, o enviarnos un email, no crea por sí mismo una relación de cliente ni profesional con Bullish Accounting LLC. Un trabajo profesional comienza solo después de que las partes aceptan el acuerdo de servicios correspondiente, que establece el alcance y las condiciones del trabajo. Por favor no envíe documentos confidenciales antes de que exista un acuerdo de servicios.' },
        { h: 'Planes contables y propuestas', p: 'Las descripciones de nuestros servicios y Planes contables son generales. El alcance, los entregables y los honorarios de cada trabajo se confirman de forma individual y por escrito antes de comenzar.' },
        { h: 'Materiales de marca', p: 'El nombre BULLISH, el logotipo original del toro, el monograma BA y el texto y diseño originales de este sitio son materiales de marca de Bullish Accounting LLC y no pueden copiarse ni usarse sin autorización.' },
        { h: 'Imágenes con licencia y contenido de terceros', p: 'Algunas fotografías de este sitio se utilizan bajo licencia de terceros y no son propiedad de Bullish Accounting LLC. Siguen sujetas a sus respectivas licencias. Los enlaces a sitios de terceros, como Instagram, se ofrecen por conveniencia; no controlamos esos sitios y no somos responsables de su contenido ni de sus prácticas.' },
        { h: 'Testimonios', p: 'Al enviar un testimonio, usted confirma que refleja su propia experiencia real. Revisamos cada testimonio antes de publicarlo y podemos rechazar o retirar cualquier testimonio. Los testimonios aprobados muestran su nombre, calificación y comentario.' },
        { h: 'Uso aceptable', p: 'Usted se compromete a no hacer un uso indebido de este sitio, por ejemplo enviando solicitudes falsas o automatizadas, enviando spam o intentando acceder a áreas restringidas o interferir con su funcionamiento.' },
        { h: 'Exactitud de la información', p: 'Procuramos que la información de este sitio sea exacta y esté actualizada, pero las leyes y normas fiscales cambian y parte del contenido puede quedar desactualizado. No garantizamos que el sitio esté completo, actualizado o libre de errores.' },
        { h: 'Limitación de responsabilidad', p: 'En la medida permitida por la ley aplicable, Bullish Accounting LLC no es responsable de pérdidas derivadas de confiar en la información general publicada en este sitio sin un acuerdo de servicios profesionales. Nada en estos términos limita una responsabilidad que no pueda limitarse según la ley aplicable, ni las obligaciones establecidas en un acuerdo de servicios firmado.' },
        { h: 'Cambios en estos términos', p: 'Podemos actualizar estos términos. La versión vigente siempre estará publicada en esta página.' },
        { h: 'Ley aplicable', p: 'Estos términos se rigen por las leyes del Estado de Florida, Estados Unidos, sin considerar sus normas sobre conflicto de leyes. Cualquier controversia derivada del uso de este sitio estará sujeta a la jurisdicción de los tribunales competentes ubicados en el Estado de Florida.' },
      ],
    },
    disclaimer: {
      h1: 'Aviso sobre servicios profesionales',
      sections: [
        { h: 'Nuestros servicios', p: 'Bullish Accounting LLC presta servicios de cumplimiento fiscal, planificación fiscal, contabilidad y asesoría dentro del alcance de las calificaciones y autorizaciones que corresponden a la firma y a su equipo.' },
        { h: 'No somos una firma de CPA ni un despacho de abogados', p: 'Bullish Accounting LLC no es una firma de CPA y no presta servicios de auditoría, revisión, atestiguamiento ni otros reservados a contadores públicos certificados con licencia. No es un despacho de abogados y no brinda asesoría legal. Nada en este sitio afirma ni da a entender que nuestros fundadores posean licencias de CPA o credenciales de Enrolled Agent.' },
        { h: 'Asuntos que requieren una autorización específica', p: 'Algunos asuntos requieren un profesional con licencia, un abogado u otra autorización específica. Esos servicios no se ofrecen a menos que existan las calificaciones y los acuerdos correspondientes. Cuando un asunto lo requiera, se lo indicaremos y, cuando corresponda, coordinaremos con profesionales calificados o le remitiremos a ellos.' },
        { h: 'No constituye asesoría individualizada', p: 'La información de este sitio es de carácter general. No constituye asesoría profesional individualizada y no debe utilizarse para su situación específica.' },
        { h: 'Sin resultados garantizados', p: 'Los resultados fiscales dependen de los hechos y circunstancias de cada cliente y de la ley aplicable, que cambia con el tiempo. No garantizamos ningún resultado fiscal ni ahorro fiscal en particular. Cada caso requiere un análisis individual.' },
        { h: 'Trabajo profesional', p: 'Los servicios profesionales se prestan solo bajo un acuerdo de servicios aceptado por las partes, que establece el alcance del trabajo.' },
      ],
    },
  },
};

export default es;
